import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { readFromLocalStorage } from "utils/helper";

const DownloadCart = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");

  const [message, setMessage] = useState("");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const fetchZipFile = async () => {
    if (!token) {
      setError(true);
      setMessage("This download link is missing required information.");
      return;
    }
    const { REACT_APP_BASE_URL, REACT_APP_API_KEY } = process.env;

    setLoading(true);

    const apiKey = REACT_APP_API_KEY;
    const userAuth = readFromLocalStorage("userAccessToken");
    let BASE_URL = REACT_APP_BASE_URL || `${window.location.origin}/api`;

    try {
      const response = await fetch(
        `${BASE_URL}/v1/downloadzipwithlogin?token=${token}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/zip",
            api_key: apiKey,
            Authorization: userAuth,
          },
        },
      );

      if (!response.ok) {
        setError(true);
        setMessage(
          response.status === 401
            ? "This link has expired. Please ask the sender to share a new link."
            : "We could not prepare this download. Please contact the sender.",
        );
        return;
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "downloaded_cart.zip";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      setError(false);
      setMessage("File downloaded successfully.");
    } catch (error) {
      setError(true);
      setMessage(
        "We could not prepare this download. Please try again.",
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchZipFile();
  }, [token]);

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>Download Cart</h1>
      </div>

      <div style={styles.content}>
        {loading ? (
          <div style={styles.spinnerContainer}>
            <div style={styles.spinner}></div>
            <p>Downloading your file, please wait...</p>
          </div>
        ) : (
          <div style={error ? styles.errorCard : styles.successCard}>
            <div style={error ? styles.errorIcon : styles.successIcon}>
              {error ? "!" : "✓"}
            </div>
            <h2 style={styles.cardTitle}>
              {error ? "Download unavailable" : "Download ready"}
            </h2>
            <p style={styles.message}>
              {message || "Preparing your download..."}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    fontFamily: "Arial, sans-serif",
    padding: "20px",
    textAlign: "center",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "20px",
  },
  backButton: {
    backgroundColor: "#007BFF",
    color: "#fff",
    border: "none",
    padding: "10px 15px",
    borderRadius: "5px",
    cursor: "pointer",
  },
  title: {
    flex: 1,
    textAlign: "center",
    margin: "0",
  },
  content: {
    marginTop: "20px",
  },
  spinnerContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  spinner: {
    width: "40px",
    height: "40px",
    border: "4px solid #f3f3f3",
    borderTop: "4px solid #007BFF",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
  message: {
    fontSize: "16px",
    color: "#4b5563",
    margin: "10px 0 0",
    lineHeight: "1.5",
  },
  errorCard: {
    maxWidth: "560px",
    margin: "40px auto 0",
    padding: "32px",
    border: "1px solid #E2E4E7",
    borderTop: "8px solid #E36E00",
    borderRadius: "12px",
    background: "#fff",
    boxShadow: "0 18px 50px rgba(17, 24, 39, 0.12)",
  },
  successCard: {
    maxWidth: "560px",
    margin: "40px auto 0",
    padding: "32px",
    border: "1px solid #E2E4E7",
    borderTop: "8px solid #10b981",
    borderRadius: "12px",
    background: "#fff",
    boxShadow: "0 18px 50px rgba(17, 24, 39, 0.12)",
  },
  errorIcon: {
    width: "58px",
    height: "58px",
    display: "grid",
    placeItems: "center",
    margin: "0 auto 18px",
    borderRadius: "50%",
    background: "#FFF4E0",
    color: "#E36E00",
    fontSize: "30px",
    fontWeight: 700,
  },
  successIcon: {
    width: "58px",
    height: "58px",
    display: "grid",
    placeItems: "center",
    margin: "0 auto 18px",
    borderRadius: "50%",
    background: "#ecfdf5",
    color: "#10b981",
    fontSize: "30px",
    fontWeight: 700,
  },
  cardTitle: {
    margin: 0,
    color: "#111827",
    fontSize: "26px",
  },
};

// Spinner animation keyframes
const spinnerStyle = document.createElement("style");
spinnerStyle.innerHTML = `
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}`;
document.head.appendChild(spinnerStyle);

export default DownloadCart;
